module.exports = __webpack_public_path__ + "static/1000-drawer-5546ecb88ff183131635c36c30c83b58.jpg";